import {Store} from 'pullstate';

export const FirebaseStore = new Store({
    error: null,
    errorCode: null,
});

export const resetError = () => {
    FirebaseStore.update(s => {
        s.error = null;
        s.errorCode = null;
    });
}
